import React, { memo, useState, useEffect } from 'react';
import cn from 'classnames';
import Style, { StyleContext } from '@Models/style';
import type { StyleProviderProps, StyleKeys } from './types';

function StyleProvider(props: StyleProviderProps): React.ReactElement {
  /* States */
  const { children } = props;
  const [styleName, setStyleName] = useState<StyleKeys>('light');
  const [dynamicStyle, setDynamicStyle] = useState<string>(
    Style.getStyle(styleName)
  );

  /* Hooks */
  useEffect(() => {
    setDynamicStyle(Style.getStyle(styleName));
  }, [styleName]);

  /* Main */
  return (
    <StyleContext.Provider value={{ styleName, setStyleName }}>
      <div className={cn('AppStyleProvider', dynamicStyle)}>{children}</div>
    </StyleContext.Provider>
  );
}

export default memo(StyleProvider);
